<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-8 d-flex align-items-center">
          <p>{{ $t('footer.copy') }}</p>
        </div>
        <div class="col-4 text-right">
          <router-link v-if="implementationCompany == 'amica'" class="logo" :to="'/'"><img src="@/assets/images/logo-claim.svg" alt="amica"></router-link>
          <router-link v-if="implementationCompany == 'hansa'" class="logo" :to="'/'"><img src="@/assets/images/logo-hansa.png" alt="hansa"></router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import { globalStore } from '@/main'

  export default {
    name: "Footer",
    computed: {
      implementationCompany () {
        return globalStore.IMPLEMENTATION_COMPANY
      }
    },
  }
</script>

<style lang="scss" scoped>
  footer {
    width: 100%;
    padding: 20px 0;
    border-top: 1px #eaeaea solid;
    background-color: #ffffff;
    font-size: 14px;
    position: fixed;
    bottom: 0px;

    .logo {

      img {
        width: 80px;
      }
    }
  }
</style>
